export default __webpack_public_path__ + "static/media/bkg--location-lifestyle-2.7d9d66ec.jpg";